import {onInViewport} from '../../../utils/onInViewport';

export const initBanner = () => {
    const components = document.querySelectorAll( 'section.cds2-banner' );

    if ( components.length )
    {
        components.forEach(( component ) => {
            const onWindowScroll = onInViewport( component, () => window.removeEventListener( 'scroll', onWindowScroll ));

            if ( component.querySelector( 'img.back' ) )
            {
                onWindowScroll();
                window.addEventListener( 'scroll', onWindowScroll );
            }          
        });
    }
};
